export const LRSNODE_CONTRACT_CONFIG = {
  address: (import.meta.env.VITE_LRSNODE_CONTRACT_ADDRESS || '') as `0x${string}`,
  abi: [{"inputs": [], "stateMutability": "nonpayable", "type": "constructor"}, {
    "anonymous": false,
    "inputs": [{"indexed": true, "internalType": "address", "name": "previousOwner", "type": "address"}, {"indexed": true, "internalType": "address", "name": "newOwner", "type": "address"}],
    "name": "OwnershipTransferred",
    "type": "event"
  }, {"inputs": [{"internalType": "string", "name": "referCode", "type": "string"}], "name": "activateReferCode", "outputs": [], "stateMutability": "nonpayable", "type": "function"}, {
    "inputs": [{"internalType": "uint256", "name": "newStock", "type": "uint256"}],
    "name": "addKeyStocks",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  }, {
    "inputs": [{"internalType": "uint256", "name": "_amountA", "type": "uint256"}, {"internalType": "uint256", "name": "_amountB", "type": "uint256"}],
    "name": "addLiquidityByLRS",
    "outputs": [{"internalType": "uint256", "name": "", "type": "uint256"}],
    "stateMutability": "payable",
    "type": "function"
  }, {"inputs": [{"internalType": "address", "name": "", "type": "address"}], "name": "addressToReferCode", "outputs": [{"internalType": "string", "name": "", "type": "string"}], "stateMutability": "view", "type": "function"}, {
    "inputs": [{
      "internalType": "uint256",
      "name": "amountToBuy",
      "type": "uint256"
    }, {"internalType": "uint256", "name": "userAmount", "type": "uint256"}], "name": "buyLRSN", "outputs": [], "stateMutability": "payable", "type": "function"
  }, {"inputs": [], "name": "buyNodeKeyWithOutRefer", "outputs": [], "stateMutability": "payable", "type": "function"}, {
    "inputs": [{"internalType": "string", "name": "referCode", "type": "string"}],
    "name": "buyNodeKeyWithRefer",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
  }, {"inputs": [{"internalType": "uint256", "name": "lockID", "type": "uint256"}], "name": "claimLockReward", "outputs": [], "stateMutability": "nonpayable", "type": "function"}, {
    "inputs": [{"internalType": "string", "name": "nodeKey", "type": "string"}, {
      "internalType": "string",
      "name": "referCode",
      "type": "string"
    }], "name": "claimReferEarning", "outputs": [], "stateMutability": "nonpayable", "type": "function"
  }, {"inputs": [{"internalType": "string", "name": "key", "type": "string"}], "name": "claimRewardLRSNode", "outputs": [], "stateMutability": "nonpayable", "type": "function"}, {
    "inputs": [],
    "name": "contractOwner",
    "outputs": [{"internalType": "address", "name": "", "type": "address"}],
    "stateMutability": "view",
    "type": "function"
  }, {"inputs": [], "name": "currentKeyBuy", "outputs": [{"internalType": "uint256", "name": "", "type": "uint256"}], "stateMutability": "view", "type": "function"}, {
    "inputs": [{"internalType": "address", "name": "user", "type": "address"}],
    "name": "getBuyNodesList",
    "outputs": [{
      "components": [{"internalType": "uint256", "name": "nodeKeyID", "type": "uint256"}, {"internalType": "string", "name": "nodeKey", "type": "string"}, {"internalType": "uint256", "name": "buyTime", "type": "uint256"}, {
        "internalType": "uint256",
        "name": "expireTime",
        "type": "uint256"
      }], "internalType": "struct LRSNode2.NodeBuyDataMap[]", "name": "", "type": "tuple[]"
    }],
    "stateMutability": "view",
    "type": "function"
  }, {"inputs": [], "name": "getKeySlots", "outputs": [{"internalType": "uint256", "name": "", "type": "uint256"}], "stateMutability": "view", "type": "function"}, {
    "inputs": [{"internalType": "address", "name": "user", "type": "address"}],
    "name": "getLockRewardList",
    "outputs": [{
      "components": [{"internalType": "uint256", "name": "lockID", "type": "uint256"}, {"internalType": "uint256", "name": "lockAmount", "type": "uint256"}, {"internalType": "uint256", "name": "lockTime", "type": "uint256"}, {
        "internalType": "uint256",
        "name": "unlockTime",
        "type": "uint256"
      }, {"internalType": "bool", "name": "isClaim", "type": "bool"}], "internalType": "struct LRSNode2.NodeRewardLockMap[]", "name": "", "type": "tuple[]"
    }],
    "stateMutability": "view",
    "type": "function"
  }, {"inputs": [{"internalType": "string", "name": "code", "type": "string"}], "name": "getReferNodesList", "outputs": [{"internalType": "string[]", "name": "", "type": "string[]"}], "stateMutability": "view", "type": "function"}, {
    "inputs": [],
    "name": "implementation",
    "outputs": [{"internalType": "address", "name": "", "type": "address"}],
    "stateMutability": "view",
    "type": "function"
  }, {"inputs": [], "name": "initContract", "outputs": [], "stateMutability": "nonpayable", "type": "function"}, {
    "inputs": [],
    "name": "larissaMainDao",
    "outputs": [{"internalType": "address", "name": "", "type": "address"}],
    "stateMutability": "view",
    "type": "function"
  }, {
    "inputs": [{"internalType": "address", "name": "", "type": "address"}, {"internalType": "uint256", "name": "", "type": "uint256"}],
    "name": "lockRewards",
    "outputs": [{"internalType": "uint256", "name": "lockID", "type": "uint256"}, {"internalType": "uint256", "name": "lockAmount", "type": "uint256"}, {"internalType": "uint256", "name": "lockTime", "type": "uint256"}, {
      "internalType": "uint256",
      "name": "unlockTime",
      "type": "uint256"
    }, {"internalType": "bool", "name": "isClaim", "type": "bool"}],
    "stateMutability": "view",
    "type": "function"
  }, {"inputs": [], "name": "maxKeyBuyAllowed", "outputs": [{"internalType": "uint256", "name": "", "type": "uint256"}], "stateMutability": "view", "type": "function"}, {
    "inputs": [{"internalType": "address", "name": "userAddress", "type": "address"}, {
      "internalType": "uint16",
      "name": "nodeCounts",
      "type": "uint16"
    }], "name": "migrateNodeKey", "outputs": [], "stateMutability": "nonpayable", "type": "function"
  }, {
    "inputs": [{"internalType": "address", "name": "", "type": "address"}, {"internalType": "uint256", "name": "", "type": "uint256"}],
    "name": "nodeBuyData",
    "outputs": [{"internalType": "uint256", "name": "nodeKeyID", "type": "uint256"}, {"internalType": "string", "name": "nodeKey", "type": "string"}, {"internalType": "uint256", "name": "buyTime", "type": "uint256"}, {"internalType": "uint256", "name": "expireTime", "type": "uint256"}],
    "stateMutability": "view",
    "type": "function"
  }, {"inputs": [{"internalType": "string", "name": "", "type": "string"}], "name": "nodeKeyOwner", "outputs": [{"internalType": "address", "name": "", "type": "address"}], "stateMutability": "view", "type": "function"}, {
    "inputs": [],
    "name": "owner",
    "outputs": [{"internalType": "address", "name": "", "type": "address"}],
    "stateMutability": "view",
    "type": "function"
  }, {"inputs": [{"internalType": "string", "name": "", "type": "string"}], "name": "pendingRewards", "outputs": [{"internalType": "uint256", "name": "", "type": "uint256"}], "stateMutability": "view", "type": "function"}, {
    "inputs": [],
    "name": "planExpireTime",
    "outputs": [{"internalType": "uint256", "name": "", "type": "uint256"}],
    "stateMutability": "view",
    "type": "function"
  }, {"inputs": [], "name": "planPrice", "outputs": [{"internalType": "uint256", "name": "", "type": "uint256"}], "stateMutability": "view", "type": "function"}, {
    "inputs": [{"internalType": "string", "name": "", "type": "string"}],
    "name": "referClaim",
    "outputs": [{"internalType": "bool", "name": "", "type": "bool"}],
    "stateMutability": "view",
    "type": "function"
  }, {"inputs": [{"internalType": "string", "name": "", "type": "string"}], "name": "referCodeToAddress", "outputs": [{"internalType": "address", "name": "", "type": "address"}], "stateMutability": "view", "type": "function"}, {
    "inputs": [{
      "internalType": "string",
      "name": "",
      "type": "string"
    }, {"internalType": "uint256", "name": "", "type": "uint256"}], "name": "referedList", "outputs": [{"internalType": "string", "name": "", "type": "string"}], "stateMutability": "view", "type": "function"
  }, {"inputs": [{"internalType": "string", "name": "key", "type": "string"}], "name": "renewNodeKey", "outputs": [], "stateMutability": "payable", "type": "function"}, {"inputs": [], "name": "renounceOwnership", "outputs": [], "stateMutability": "nonpayable", "type": "function"}, {
    "inputs": [],
    "name": "rewardLockTime",
    "outputs": [{"internalType": "uint256", "name": "", "type": "uint256"}],
    "stateMutability": "view",
    "type": "function"
  }, {"inputs": [{"internalType": "uint256", "name": "lrsnValue", "type": "uint256"}], "name": "sendLrsnToMainDao", "outputs": [], "stateMutability": "nonpayable", "type": "function"}, {
    "inputs": [{"internalType": "address", "name": "newAddress", "type": "address"}],
    "name": "setMainDao",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  }, {"inputs": [{"internalType": "address", "name": "newOwner", "type": "address"}], "name": "transferOwnership", "outputs": [], "stateMutability": "nonpayable", "type": "function"}, {
    "inputs": [{"internalType": "string[]", "name": "nodes", "type": "string[]"}, {
      "internalType": "uint256[]",
      "name": "rewards",
      "type": "uint256[]"
    }], "name": "updateRewards", "outputs": [], "stateMutability": "nonpayable", "type": "function"
  }, {"stateMutability": "payable", "type": "receive"}],
} as const;

export const LRSNODE_V3_CONTRACT_CONFIG = {
  address: (import.meta.env.VITE_LRSNODE_3_CONTRACT_ADDRESS || '') as `0x${string}`,
  abi: [
    {"inputs": [{"internalType": "string", "name": "referCode", "type": "string"}], "name": "activateReferCode", "outputs": [], "stateMutability": "nonpayable", "type": "function"},
    {"inputs": [{"internalType": "address", "name": "", "type": "address"}], "name": "addressToReferCode", "outputs": [{"internalType": "string", "name": "", "type": "string"}], "stateMutability": "view", "type": "function"},
    {"inputs": [{"internalType": "uint256", "name": "planId", "type": "uint256"}], "name": "buyNodeKeyWithOutRefer", "outputs": [], "stateMutability": "payable", "type": "function"},
    {"inputs": [{"internalType": "uint256", "name": "planId", "type": "uint256"}, {"internalType": "string", "name": "referCode", "type": "string"}], "name": "buyNodeKeyWithRefer", "outputs": [], "stateMutability": "payable", "type": "function"},
    {"inputs": [{"internalType": "string", "name": "nodeKey", "type": "string"}, {"internalType": "string", "name": "referCode", "type": "string"}], "name": "claimReferEarning", "outputs": [], "stateMutability": "nonpayable", "type": "function"},
    {"inputs": [{"internalType": "string", "name": "key", "type": "string"}], "name": "claimRewardLRSNode", "outputs": [], "stateMutability": "nonpayable", "type": "function"},
    {"inputs": [], "name": "currentKeyBuy", "outputs": [{"internalType": "uint256", "name": "", "type": "uint256"}], "stateMutability": "view", "type": "function"},
    {"inputs": [{"internalType": "address", "name": "user", "type": "address"}], "name": "getBuyNodesList", "outputs": [{"components": [{"internalType": "uint256", "name": "nodeKeyID", "type": "uint256"}, {"internalType": "string", "name": "nodeKey", "type": "string"}, {"internalType": "uint256", "name": "buyTime", "type": "uint256"}, {"internalType": "uint256", "name": "expireTime", "type": "uint256"}, {"internalType": "uint256", "name": "totalEarn", "type": "uint256"}, {"internalType": "uint256", "name": "planId", "type": "uint256"}], "internalType": "struct LRSNode3.NodeBuyDataMap[]", "name": "", "type": "tuple[]"}], "stateMutability": "view", "type": "function"},
    {"inputs": [{"internalType": "address", "name": "user", "type": "address"}], "name": "getNode2MigrationStats", "outputs": [{"components": [{"internalType": "uint256", "name": "node2TotalNodes", "type": "uint256"}, {"internalType": "uint256", "name": "node2MigratableNodes", "type": "uint256"}, {"internalType": "uint256", "name": "node2ExpiredNodes", "type": "uint256"}, {"internalType": "uint256", "name": "alreadyMigratedNodes", "type": "uint256"}, {"internalType": "uint256", "name": "pendingRewardBlockedNodes", "type": "uint256"}, {"internalType": "uint256", "name": "unclaimedLockRewards", "type": "uint256"}, {"internalType": "uint256", "name": "unclaimedReferRewards", "type": "uint256"}, {"internalType": "bool", "name": "hasEnoughSlots", "type": "bool"}, {"internalType": "bool", "name": "canMigrate", "type": "bool"}], "internalType": "struct LRSNode3.MigrationStats", "name": "stats", "type": "tuple"}], "stateMutability": "view", "type": "function"},
    {"inputs": [{"internalType": "string", "name": "code", "type": "string"}], "name": "getReferNodesList", "outputs": [{"internalType": "string[]", "name": "", "type": "string[]"}], "stateMutability": "view", "type": "function"},
    {"inputs": [], "name": "migrateFromNode2", "outputs": [], "stateMutability": "nonpayable", "type": "function"},
    {"inputs": [{"internalType": "string", "name": "", "type": "string"}], "name": "pendingRewards", "outputs": [{"internalType": "uint256", "name": "", "type": "uint256"}], "stateMutability": "view", "type": "function"},
    {"inputs": [{"internalType": "uint256", "name": "planId", "type": "uint256"}], "name": "planAvailable", "outputs": [{"internalType": "uint256", "name": "", "type": "uint256"}], "stateMutability": "view", "type": "function"},
    {"inputs": [{"internalType": "uint256", "name": "", "type": "uint256"}], "name": "plans", "outputs": [{"internalType": "uint256", "name": "usdCents", "type": "uint256"}, {"internalType": "uint256", "name": "duration", "type": "uint256"}, {"internalType": "uint256", "name": "maxStock", "type": "uint256"}, {"internalType": "uint256", "name": "soldStock", "type": "uint256"}, {"internalType": "bool", "name": "isActive", "type": "bool"}], "stateMutability": "view", "type": "function"},
    {"inputs": [{"internalType": "string", "name": "", "type": "string"}], "name": "referClaim", "outputs": [{"internalType": "bool", "name": "", "type": "bool"}], "stateMutability": "view", "type": "function"},
    {"inputs": [{"internalType": "string", "name": "", "type": "string"}], "name": "referCodeToAddress", "outputs": [{"internalType": "address", "name": "", "type": "address"}], "stateMutability": "view", "type": "function"},
    {"inputs": [{"internalType": "uint256", "name": "planId", "type": "uint256"}], "name": "requiredWeiForPlan", "outputs": [{"internalType": "uint256", "name": "", "type": "uint256"}], "stateMutability": "view", "type": "function"},
    {"inputs": [{"internalType": "string", "name": "key", "type": "string"}], "name": "renewNodeKey", "outputs": [], "stateMutability": "payable", "type": "function"}
  ],
} as const;

// Types for contract responses
export interface NodeInfo {
  nodeKeyID: bigint;
  nodeKey: string;
  buyTime: bigint;
  expireTime: bigint;
  pendingReward?: bigint;
}

export interface NodeInfoV3 {
  nodeKeyID: bigint;
  nodeKey: string;
  buyTime: bigint;
  expireTime: bigint;
  totalEarn: bigint;
  planId: bigint;
  pendingReward?: bigint;
}

export interface LockRewardInfo {
  lockID: bigint;
  lockAmount: bigint;
  lockTime: bigint;
  unlockTime: bigint;
  isClaim: boolean;
}

export interface ReferNodeInfo {
  nodeKey: string;
  isClaimed: boolean;
}

/** Matches `LRSNode3.getNode2MigrationStats` / `MigrationStats` in docs/LRSNode3.sol */
export interface Node2MigrationStats {
  node2TotalNodes: bigint;
  /** Active on Node 2: `expireTime > now` (only these can migrate). */
  node2MigratableNodes: bigint;
  /** Expired on Node 2: skipped by `migrateFromNode2`. */
  node2ExpiredNodes: bigint;
  /** Migrated keys among migratable (non-expired) only. */
  alreadyMigratedNodes: bigint;
  pendingRewardBlockedNodes: bigint;
  unclaimedLockRewards: bigint;
  unclaimedReferRewards: bigint;
  hasEnoughSlots: boolean;
  canMigrate: boolean;
}

